import PropTypes from 'prop-types';
import { ShareSettingsIcon } from 'shared/components/ShareSettingsButton';
import { DocType } from 'shared/constants/docs';
import { SHARE_TYPES } from 'shared/constants/share';
import ProjectFileCountIcon from 'shared/_model/project-details/ProjectFileCountIcon';
import styles from 'shared/Pages/common/ProjectsList/ProjectListItemIcons.module.scss';

const getCount = (item, fileType) => (
	(item && item._totals && !!item._totals.fileCount)
		? item._totals.fileCount[fileType]
		: null
);
const ProjectListItemIcons = ({ item }) => (
  <>
		{/* styles.small is a temporal hack to make it smaller */}
		<span className={styles.small}>
			<ProjectFileCountIcon type={DocType.FILE_FINISH_VIDEO} count={getCount(item, DocType.FILE_FINISH_VIDEO)} />
			<ProjectFileCountIcon type={DocType.FILE_FINISH_AUDIO} count={getCount(item, DocType.FILE_FINISH_AUDIO)} />
		</span>
    <ShareSettingsIcon sharing={item.sharing} type={SHARE_TYPES.project} />
  </>
);
ProjectListItemIcons.propTypes = {
  item: PropTypes.shape({
    _id: PropTypes.string,
    _totals: PropTypes.shape({
      fileCount: PropTypes.shape({}),
    }),
    sharing: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
  }),
};

export default ProjectListItemIcons;
